module.exports = __webpack_public_path__ + "img/read_guide.de4ba541.png";